import { useState } from "react";
import { X } from "lucide-react";
import { Link } from "react-router-dom";

// export default function PromoBanner() {
//   const [visible, setVisible] = useState(true);

//   return (
//     <>
//       {visible && (
//         <div className="w-full bg-blue-600 text-white px-3 py-1.5 flex items-center justify-between text-xs sm:text-sm font-medium">
//           <p className="truncate flex-1 text-center pr-2">
//             🚀 Earn 1000 free credits to avail advanced features! 
//             <span className="hidden sm:inline"> Join the Waitlist for the PRO version & boost your AI workflow! </span>
//             <span className="hidden sm:inline"><a href="https://datacreatorai.com/pricing" className="text-white underline"> Subscribe to Pro</a></span>
//           </p>
//           <button 
//             onClick={() => setVisible(false)} 
//             className="p-0.5 hover:bg-blue-700 rounded"
//             aria-label="Close banner"
//           >
//             <X className="w-4 h-4" />
//           </button>
//         </div>
//       )}
//     </>
//   );
// }

export default function PromoBanner() {
  const [visible, setVisible] = useState(true);

  return (
    <>
      {visible && (
        <div className="w-full bg-blue-600 text-white px-3 py-1.5 flex items-center justify-between text-xs sm:text-sm font-medium">
          {/* Combined View */}
          <p className="flex-1 text-center pr-2 text-xs sm:text-sm">
            🚀 UNLIMITED DATA GENERATION | Export up to 500 rows for free in CSV, JSON or JSONL formats | Clean your data until it feels right
          </p>

          <button
            onClick={() => setVisible(false)}
            className="p-0.5 hover:bg-blue-700 rounded transition-colors"
            aria-label="Close banner"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      )}
    </>
  );
}